export default __webpack_public_path__ + "static/media/detail product.83435b56.png";